"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var El = _interopRequireWildcard(require("./Button.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/** Style */

var Button = function Button(_ref) {
  var color = _ref.color,
    variant = _ref.variant,
    children = _ref.children,
    buttonLoading = _ref.buttonLoading,
    fullWidth = _ref.fullWidth,
    rounded = _ref.rounded,
    loadingSize = _ref.loadingSize,
    disabled = _ref.disabled,
    actionClick = _ref.actionClick,
    customId = _ref.customId,
    size = _ref.size,
    customClass = _ref.customClass,
    uppercase = _ref.uppercase,
    tabIndex = _ref.tabIndex,
    type = _ref.type;
  if (buttonLoading) return /*#__PURE__*/_react["default"].createElement(El.ButtonLoading, {
    loadingSize: loadingSize
  });
  var handleClick = function handleClick() {
    return actionClick && actionClick();
  };
  return /*#__PURE__*/_react["default"].createElement(El.Button, {
    id: customId,
    type: type,
    color: color,
    variant: variant,
    size: size,
    disabled: disabled,
    fullWidth: fullWidth,
    rounded: rounded,
    onClick: handleClick,
    className: "".concat(customClass),
    uppercase: uppercase,
    tabIndex: tabIndex
  }, children);
};
Button.defaultProps = {
  customId: '',
  color: 'default',
  variant: 'contained',
  size: 'sm',
  buttonLoading: false,
  fullWidth: false,
  disabled: false,
  loadingSize: '30px',
  customClass: '',
  uppercase: true,
  tabIndex: '0',
  type: 'button',
  rounded: false,
  actionClick: function actionClick() {
    return null;
  }
};
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map